import React, { useEffect } from "react";
import { usePictureContext } from "../../context/pictureContext";
import { useInView } from "react-intersection-observer";

const LoadMoreTrigger = () => {
  const { setPage, isLoadingMore } = usePictureContext();
  const { ref, inView } = useInView({ threshold: 0.1 });

  useEffect(() => {
    if (inView && !isLoadingMore) {
      setPage(prevPage => prevPage + 1);
    }
  }, [inView, setPage, isLoadingMore]);

  return (
    <div ref={ref} style={{ height: "20px", padding: "10px", textAlign: "center" }}>
      {isLoadingMore && <div>Loading more photos...</div>}
    </div>
  );
};

export default LoadMoreTrigger;
